export var parseQueryStringParams = function parseQueryStringParams(search) {
  return new URLSearchParams(search !== null && search !== void 0 ? search : window.location.search);
};